module.exports = __webpack_public_path__ + "img/pchome24hlogo.2b18eb4d.jpg";